import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, Platform, StatusBar, I18nManager, TouchableOpacity, Linking, } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import AwesomeAlert from 'react-native-awesome-alerts';
import { sendOtp } from '../store/action/userLogin';
import { Modal, NativeBaseProvider, useMediaQuery } from 'native-base';
import { Ionicons } from '@expo/vector-icons';
 import * as Updates from 'expo-updates';


//  I18nManager.forceRTL(true);
// I18nManager.allowRTL(false);











const Login = (props) => {


  const [task, setTask] = useState("");
  const [show, setShow] = useState(false);
  const [Law, setLAW] = useState(false);
  const [ShowLaw, setShowLaw] = useState(true);
  const [filtermodal, setfiltermodal] = useState(false)

  const sendOtpHandler = async () => {
    try {
      await sendOtp(task)


    } catch (err) {
      console.log(err);
    }
  };




  useEffect(() => {

    // if (ShowLaw==true) {
    //   setLAW(true)
    // }




    if (I18nManager.isRTL) {
      I18nManager.forceRTL(false);
      Updates.reloadAsync();
    }

  })






  const handleOpenWithLinking = () => {
    Linking.openURL("https://cutunix.ir/rules");
  };

  const [isSmallScreen] = useMediaQuery({
    // minHeight: 280,
    // maxHeight: 480,
    maxWidth: 500
  });

  return (

    // <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
    <NativeBaseProvider>



      <Modal justifyContent="center" size="lg"
        isOpen={filtermodal} onPress={() => setfiltermodal(false)}>
        <Modal.Content style={{ borderRadius: 30 }}>
          <Modal.Body >

            <View style={{ width: "100%", height: 400 }}>
              <View style={{ width: "100%", height: 40, flexDirection: "row" }}>


                <Ionicons onPress={() => setfiltermodal(false)} name="close" size={20} color={Colors.black} />
                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, left: 80, position: "absolute" }}>راهنمای نصب نسخه IOS</Text>
              </View>




              <View style={{ width: "100%", height: 280, marginBottom: 10, }}>




                {/* <Ionicons onPress={() => setState({ ...State, ActService: "send" })} name={State.ActService !== "send" ? "square-outline" : 'checkbox'}
                    size={28} color={State.ActService !== "send" ? Colors.secondText3 : Colors.yellowlight} /> */}


                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, marginBottom: 20, marginTop: 10 }}>ابتدا از طریق مرورگر <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, }}> safari </Text> وارد سایت   پلنرس شوید. </Text>

                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, }}>سپس روی گزینه<Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, }}> share </Text>کلیک کرده.</Text>

                <Ionicons name="share-outline" size={35} color={Colors.secondText3} style={{ position: "absolute", left: 130, top: 110, }} />

                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, marginTop: 90 }}>از منوی فوق گزینه ی<Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, }}> Add to Home Screen </Text> زده و روی <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, }}> Save </Text> کلیک کنید.</Text>

                <Ionicons name="add-circle-outline" size={35} color={Colors.secondText3} style={{ position: "absolute", left: 130, top: 230, }} />

              </View>








              <Btn
                touchableStyle={{
                  width: "80%",
                  height: 50,
                  backgroundColor: Colors.primary,
                }}
                textStyle={{ bottom: 10, fontSize: 16 }}
                style={{ marginTop: 10, left: 25 }}
                onPress={() => {

                  setfiltermodal(false)

                }}
                colorspin={Colors.background}
                sizespin={25}
                label="باشه"

              />





            </View>


          </Modal.Body>

        </Modal.Content>
      </Modal>


      <View style={{
        width: isSmallScreen ? "100%" : 500,
        height: "100%",
        marginLeft:isSmallScreen?0:"35%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
      }}>


        <StatusBar backgroundColor={Colors.background} />



        <View style={styles.viewlogo}>
          <Text style={{ fontFamily: "MontserratBold", fontSize: 25, bottom: 150, position: "absolute",marginBottom:20 }}>به پلنرس خوش آمدید</Text>
          <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.secondText3 }}>لطفا شماره موبایل خودرا وارد کنید </Text>

        </View>




        <INPU
          label="شماره موبایل"
          styleview={{ marginTop: 70, }}
          placeholder="0913 xxx xxxx"
          keyboardType="numeric"
          value={task}
          mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
          onChangeText={(masked) => setTask(masked)}
          styleinput={Platform.OS === "web" && { outlineColor: Colors.primary,outlineStyle: 'none' }}
        />



        {/* <TouchableOpacity onPress={() => {

          if (Platform.OS == "web") {
            handleOpenWithLinking()
          } else {
            props.navigation.navigate("web", { addressweb: "https://npln.ir" })
          }
        }
        }



          style={{ width: "100%", height: 50, top: "10%", alignItems: "center", justifyContent: "center" }}>
          <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.primary }}>
            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black }}> ورود به منزله قبول کردن </Text>
            قوانین و مقررات
            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black }}> می باشد. </Text>
          </Text>
        </TouchableOpacity> */}





        <AwesomeAlert
          show={Law}
          showProgress={false}
          title="هشدار!"
          message="اگر زبان تلفن شما فارسی است لطفا یکبار از برنامه خارج شوید."
          closeOnTouchOutside={true}
          closeOnHardwareBackPress={false}
          showCancelButton={true}
          showConfirmButton={true}
          cancelText="خیر"
          confirmText="باشه"
          confirmButtonColor="#DD6B55"
          onCancelPressed={() => {
            setLAW(false);
            setShowLaw(false)
          }}
          onConfirmPressed={() => {
            setLAW(false);
            setShowLaw(false)
          }}

          titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, }}
          messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
          confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
          confirmButtonStyle={{ width: "45%", height: 40, alignItems: "center", backgroundColor: Colors.primarydark, }}
          cancelButtonStyle={{ width: "45%", height: 40, backgroundColor: Colors.success, alignItems: "center" }}
          cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
        />




        <AwesomeAlert
          show={show}
          showProgress={false}
          title="خطا"
          message="شماره تلفن را صحیح وارد کنید"
          closeOnTouchOutside={true}
          closeOnHardwareBackPress={false}
          // showCancelButton={true}
          showConfirmButton={true}
          // cancelText="باشه"
          confirmText="باشه"
          confirmButtonColor="#DD6B55"
          // onCancelPressed={() => {
          //   setShow(false);
          // }}
          onConfirmPressed={() => {
            setShow(false);
          }}
          titleStyle={{ fontFamily: "MontserratBold", fontSize: 13 }}
          messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
          confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
        />
























        <Btn
          label="ثبت نام / ورود"
          style={{ width: "100%", marginLeft: "5%", marginTop: 120, }}
          textStyle={{ bottom: 10 }}

          onPress={
            () => {
              if (task.length === 11) {
                sendOtpHandler();

                props.navigation.navigate("otp", {
                  number: task

                });
              } else {

                setShow(true);

              }
            }}
        />

        {Platform.OS == "web"
          ?


          <TouchableOpacity onPress={() => setfiltermodal(true)} style={{ width: "100%", height: 50, marginTop: 10, justifyContent: "center", alignItems: "center" }}>
            <Text style={{ fontFamily: "Montserrat", fontSize: 18, color: Colors.secondText3 }}>راهنمای نصب نسخه IOS</Text>
          </TouchableOpacity> :
          null
        }

      </View>
    </NativeBaseProvider>
    // </TouchableWithoutFeedback>

  );
}

const styles = StyleSheet.create({

  viewContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: Colors.background
  },
  viewlogo: {
    width: "100%",
    height: 100,
    alignItems: "center",
    justifyContent: "center",
    marginTop: "40%"
  },

})




export default Login

